// useScrollToBottom.ts
import { useEffect, useState } from "react";

const UseScrollToBottom = () => {
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const outerWindowHeight = window.outerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const scrollTop = window.scrollY;
      if (scrollTop + outerWindowHeight + windowHeight >= docHeight) {
        setIsBottom(true);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return isBottom;
};

export default UseScrollToBottom;
